import React from "react";
import { Grid, Paper, RadioGroup, FormControlLabel, Radio, Typography } from "@mui/material";

const SelectableRadioGroup = ({ options, selectedValue, setSelectedValue, setDialogOpen, allowedOptions = [] }) => {
  return (
    <RadioGroup
      value={selectedValue}
      onChange={(e) => {
        setSelectedValue(e.target.value);
        setDialogOpen(true); // Open dialog when a criteria is selected
      }}
    >
      <Grid container spacing={2}>
        {options.map((option, index) => {
          const isAllowed = allowedOptions.includes(option);
          const shouldBeChecked = allowedOptions.length > 0 ? isAllowed : false;

          return (
            <Grid item xs={6} key={index}>
              <Paper
                variant='outlined'
                sx={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: 2,
                  borderColor: "#757575",
                }}
              >
                <FormControlLabel
                  value={option}
                  control={<Radio sx={{ color: "#E4E4E4" }} checked={shouldBeChecked} />}
                  label={<Typography sx={{ fontSize: "14px" }}>{option}</Typography>}
                  sx={{ width: "100%", margin: 0 }}
                />
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </RadioGroup>
  );
};

export default SelectableRadioGroup;
